"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorFunctionFactoryTermLangdir = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const TermFunctionLangdir_1 = require("./TermFunctionLangdir");
/**
 * A comunica TermFunctionLangdir Function Factory Actor.
 */
class ActorFunctionFactoryTermLangdir extends bus_function_factory_1.ActorFunctionFactoryDedicated {
    constructor(args) {
        super({
            ...args,
            functionNames: [utils_expression_evaluator_1.SparqlOperator.LANGDIR],
            termFunction: true,
        });
    }
    async run(_) {
        return new TermFunctionLangdir_1.TermFunctionLangdir();
    }
}
exports.ActorFunctionFactoryTermLangdir = ActorFunctionFactoryTermLangdir;
//# sourceMappingURL=ActorFunctionFactoryTermLangdir.js.map